import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Row, Col, Card, CardBody, Button, FormGroup, Label } from "reactstrap";
import { Form, Input } from '@availity/form';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css'
import { PageTitle } from '../../layout/components/PageTitle';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { lavakleenApi } from '../../api/lavakleenApi';
import { convertArrayOfObjectsToCSV, filterDataFromApi } from '../../api/providers/providers';
import { useSelector } from 'react-redux';

const headers = {
    'Authorization' : 'Bearer ' + localStorage.getItem('sToken')
};

export const CompanyPage = forwardRef( (props, ref) => {
    useImperativeHandle( ref, () => ({
        async filterData(values){
            const result = await filterDataFromApi('Company/getCompaniesList', values, headers);
            setData(result.companiesList)
        },

        async restore() {
            await getCompanies()
        }
    }) )

    const navigate = useNavigate();

    const { id, isProcessing } = useSelector( state => state.auth )

    const [data, setData] = useState([]);
    const [userPermissions, setUserPermissions] = useState(JSON.parse( localStorage.getItem('userPermissions') ))
    const [permission, setPermission] = useState(null)
    const [searchData, setSearchData] = useState({
        filterBusinessName: '',
        // filterCompanyName: '',
    })

    const columns = [
        {
            name: "ID",
            selector: row => row.idCompany,
            sortable: true,
            width: '80px',
        },
        // {
        //     name: "Razón Social",
        //     id: "lastName",
        //     selector: row => row.sBuinessName,
        //     sortable: true,
        // },
        
        {
            name: "Nombre",
            selector: row => row.sCompanyName,
            sortable: true,
        },
        {
            name: "Dirección",
            selector: row => row.sAddress,
            sortable: true,
            wrap: true,
        },
        // {
        //     name: "RFC",
        //     selector: row => row.sRfc,
        //     sortable: true,
        // },
        
        {
            name: "Teléfono",
            selector: row => row.sPrincipalPhone,
            sortable: true,
            width: '150px',
        },
        // {
        //     name: "Website",
        //     selector: row => row.sWebsite,
        //     sortable: true,
        // },
        {
            name: "Estatus",
            selector: row => row.sStatusCompany,
            sortable: true,
            width: '100px',
        },
        {
            name: "Fecha alta",
            selector: row => row.dRegisterDate,
            sortable: true,
            width: '180px',
        },
        {
            name: "Opciones",
            cell: (row) => (
                <>
                    <Link to={ `/pages/new-company/${row.idCompany}` } className="btn btn-primary">
                        <i className="lnr-pencil"></i>
                    </Link>
                    <Button color="danger" onClick={ () => deleteCompany(row.idCompany) }><i className="lnr-trash"></i></Button>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            button: true,
        },
    ];

    const onAddClick = () => {
        navigate('/pages/new-company', {})
    }

    const getCompanies = async () => {
        await lavakleenApi.get(`Company/getCompaniesList?FilteredIdUser=${id}`, {
            headers
        }).then( response => {
            setData( response.data.companiesList );
        } )
    }

    const deleteCompany = (idCompany) => {
        const userPerm = userPermissions.find( userPermission => userPermission.sModuleDetail === 'Empresas')

        if(userPerm.bDelete !== true) {
            Swal.fire({
                title: 'Error',
                text: 'No tienes permisos para usar esta función',
                icon: 'error',
            })
            return
        }

        Swal.fire({
            title: 'Aviso',
            text: "¿Está seguro de realizar esta acción?.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, realizarla!'
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                await lavakleenApi.post(`Company/deleteCompany?idCompany=${idCompany}`, {}, {
                    headers
                }).then( response => {
                    if(response.data.bResult == true && response.data.sErrors.length == 0)
                        getCompanies();
                } )
            }
        })
    }

    const downloadCsv = () => {
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV(data);
        const BOM = "\uFEFF";
        if (csv == null) return;
        
        const filename = 'empresas.csv';

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${BOM + csv}`;
        }
        
        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }

    const checkPermissions = () => {
        const userPerm = userPermissions.find( userPermission => userPermission.sModuleDetail === 'Empresas')
        setPermission(userPermissions.find( userPermission => userPermission.sModuleDetail === 'Empresas'))
        
        if(userPerm.bList !== true) {
            Swal.fire({
                title: 'Error',
                text: 'No tienes permisos para usar esta función',
                icon: 'error',
            })

            navigate(`/pages/dashboard`)
        }
    }

    useEffect(() => {
        checkPermissions();
        getCompanies();
    }, [])
    

    return (
        <>
            <TransitionGroup>
                <CSSTransition
                    component="div"
                    classNames="TabsAnimation"
                    appear={true}
                    timeout={1500} enter={false} exit={false}>
                        <div>
                            <PageTitle
                                heading="Empresas"
                                subheading="Gestion de empresas del sistema"
                                icon="lnr-apartment icon-gradient bg-ripe-malin"
                            />
                            <ul className="body-tabs body-tabs-layout tabs-animated body-tabs-animated nav">
                                {
                                    permission !== null && permission.bCreate === true
                                    ? (
                                        <li className="nav-item">
                                            <Button className="mb-2 me-2" color="primary"
                                                onClick={ onAddClick }
                                            >
                                                Agregar
                                            </Button>
                                        </li>
                                    )
                                    : ''
                                }

                                {
                                    permission !== null && permission.bExport === true
                                    ? (
                                        <li className="nav-item">
                                            <Button className="mb-2 me-2" color="danger"
                                                onClick={ () => downloadCsv()}
                                            >
                                                Exportar
                                            </Button>
                                        </li>
                                    )
                                    : ''
                                }
                            </ul>
                            <Row>
                                <Col md="12">
                                    <Card className="main-card mb-3">
                                        <CardBody>
                                        <DataTable data={data}
                                            columns={columns}
                                            pagination
                                            fixedHeader
                                            fixedHeaderScrollHeight="500px"
                                        />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                </CSSTransition>
            </TransitionGroup>
        </>
    )
})
